<template>
  <div class="page-container">
    <a-page-header class="page-header flex-center" @back="back">
      <div slot="title" style="cursor: pointer" @click="back">返回 百日誓师</div>
      <div>
        <a-button type="primary" @click="createCourse">创建</a-button>
      </div>
    </a-page-header>
    <a-table
      :rowKey="rowKey"
      :columns="columns"
      :data-source="dataSource"
      :expandedRowKeys="expandedRowKeys"
      :showHeader="false"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
      @expandedRowsChange="expandedRowsChange"
    >
      <div slot="operation" slot-scope="text, record" class="action-detail">
        <a-dropdown placement="bottomCenter" :overlayStyle="{ width: '80px' }">
          <span v-if="userInfo().username === 'admin'">添加</span>
          <a-menu slot="overlay">
            <a-menu-item v-for="item in dropdownList" :key="item.key">
              <div style="width: 100%; text-align: center" @click="addResources(item, record)">
                {{ item.name }}
              </div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-divider type="vertical" v-if="userInfo().username === 'admin'" style="margin: 0 15px" />
        <span v-if="userInfo().username === 'admin'" @click="editRecord(record)">编辑</span>
        <a-divider v-if="userInfo().username === 'admin'" type="vertical" style="margin: 0 15px" />
        <a-popconfirm
          title="确定要删除该记录吗？"
          ok-text="是"
          cancel-text="否"
          @confirm="deleteRecord(record)"
          @cancel="() => {}"
        >
          <span v-if="userInfo().username === 'admin'" :style="{ color: '#f81d22' }">删除</span>
        </a-popconfirm>
      </div>
      <!--      <div>{{ record.ceremonyItemContentList }}</div>-->
      <a-table
        slot="expandedRowRender"
        slot-scope="record"
        :data-source="record.ceremonyItemContentList"
        :columns="innerColumns"
        :pagination="false"
        :showHeader="false"
      >
        <div slot="operation" slot-scope="text, record" class="action-detail">
          <span @click="editResources(record)">编辑</span>
          <a-divider
            v-if="userInfo().username === 'admin'"
            type="vertical"
            style="margin: 0 15px"
          />
          <a-popconfirm
            title="确定要删除该记录吗？"
            ok-text="是"
            cancel-text="否"
            @confirm="deleteResources(record)"
            @cancel="() => {}"
          >
            <span v-if="userInfo().username === 'admin'" :style="{ color: '#f81d22' }">删除</span>
          </a-popconfirm>
        </div>
      </a-table>
    </a-table>
    <CreateCourseOath ref="createCourseOathRef" :recordData="recordData" @refreshData="loadData" />
    <component
      :is="comInfo.component"
      ref="modalRef"
      :recordData="recordData"
      @refreshData="loadData"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CreateCourseOath from './components/CreateCourseOath.vue'
import VideoModal from './components/VideoModal'
import AudioModal from './components/AudioModal.vue'
import EvaluationModal from './components/EvaluationModal.vue'
import DaySigningModal from './components/DaySigningModal.vue'
import ArticlesModal from './components/ArticlesModal.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, deleteAction } from '@api/manage'
import { getStoreHttpUrl, getDateDiff } from '@/utils/util'
import moment from 'moment'
import TableList from '@comp/chart/TableList.vue'

export default {
  name: 'HundredDayOathDetail',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    CreateCourseOath,
    VideoModal,
    AudioModal,
    EvaluationModal,
    DaySigningModal,
    ArticlesModal,
  },
  data() {
    return {
      columns: [
        {
          title: '标题',
          dataIndex: 'itemTime',
          customRender: (_, record) => {
            return (
              <div>
                <span>{moment(record.itemDate).format('YYYY年MM月DD日')}</span>
                <span style="margin-left: 20px">
                  {getDateDiff(record.itemDate, this.endDate)}天
                </span>
                <span style="margin-left: 20px">标题：{record.itemTitle}</span>
              </div>
            )
          },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          align: 'right',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      innerColumns: [
        {
          title: '标题',
          dataIndex: 'title',
          align: 'left',
          customRender: (_, record) => {
            return (
              <div class="flex-align-center">
                <a-tag
                  color={
                    ['red', 'orange', 'green', 'cyan', 'blue', 'purple'][[record.contentType - 1]]
                  }
                >
                  {['视频', '音频', '测评', '文章', '日签', '工具'][record.contentType - 1]}
                </a-tag>
                <span class="inter-img ">
                  {record.coverUrl && (
                    <img
                      style="width: 100%; height: 100%; "
                      src={getStoreHttpUrl(record.coverUrl)}
                      alt=""
                    />
                  )}
                </span>
                <span>{record.title}</span>
              </div>
            )
          },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          align: 'right',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      dropdownList: [
        { key: 1, name: '视频', component: 'VideoModal' },
        { key: 2, name: '音频', component: 'AudioModal' },
        { key: 3, name: '测评', component: 'EvaluationModal' },
        { key: 4, name: '文章', component: 'ArticlesModal' },
        { key: 5, name: '日签', component: 'DaySigningModal' },
        { key: 6, name: '工具', component: 'ArticlesModal' },
      ],
      comInfo: {},
      recordData: {},
      disableMixinCreated: true,
      isExpandFirst: true, // 展开首行
      url: {
        list: '/ceremonyItem/itemContent',
        importExcelUrl: '',
        exportXlsUrl: '',
      },
      isorter: {
        column: 'itemDate',
        order: 'desc',
      },
      endDate: '', // 高考结束日期
    }
  },
  created() {
    const queryData = this.$router.history.current.query
    if (queryData) {
      this.$set(this.queryParam, 'ceremonyId', queryData.ceremonyId)
      this.endDate = moment(queryData.endDate).format('YYYY-MM-DD')
      this.recordData = queryData
    }
    this.loadData()
  },
  methods: {
    ...mapGetters(['userInfo']),
    back() {
      // this.$router.push('/school/AppPage/HundredDayOath');
      this.$router.go(-1)
    },
    createCourse() {
      console.log('createCourse', this.recordData)
      this.$refs.createCourseOathRef.showModal({
        ceremonyId: this.recordData.ceremonyId,
        endDate: this.recordData.endDate,
      })
    },
    editRecord(record) {
      const recordInfo = {
        ...this.recordData,
        ...record,
        ceremonyItemId: record.id,
      }
      this.$refs.createCourseOathRef.showModal(recordInfo)
    },
    deleteRecord(record) {
      deleteAction('/ceremonyItem/delete', { ceremonyItemId: record.id, ...this.recordData }).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.message || '删除成功')
            this.loadData()
          }
        }
      )
    },
    addResources(item, record) {
      console.log('添加--', record)
      this.comInfo = item
      const recordInfo = {
        ...this.recordData,
        ceremonyItemId: record.id,
        contentType: item.key,
      }
      this.$nextTick(() => {
        this.$refs.modalRef.showModal(recordInfo)
      })
    },
    editResources(record) {
      console.log('编辑--', record)
      this.comInfo = this.dropdownList.find((item) => item.key == record.contentType)
      const recordInfo = {
        ...this.recordData,
        ...record,
      }
      console.log('实例信息：', record)
      this.$nextTick(() => {
        this.$refs.modalRef.showModal(recordInfo)
      })
    },
    deleteResources(record) {
      console.log('删除记录：', record)
      deleteAction('/ceremonyItemContent/delete', { id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success(res.message || '删除成功')
          this.loadData()
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding: 0;
  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
}
.action-detail {
  padding: 0 20px;
  color: #0077fa !important;
  cursor: pointer !important;
  .forbidden {
    pointer-events: none;
    cursor: default;
    color: #8bc1f3;
  }
}
.inter-img {
  display: inline-block;
  width: 50px;
  height: 30px;
  margin: 0 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: linear-gradient(
    45deg,
    #feb47b,
    #fff7e6,
    #fabb89
  ); /* 45deg表示从左下到右上的斜向渐变 */
  overflow: hidden;
}
</style>
